import React, { useState } from "react";
import "./Searchbar.css";
import { AiOutlineSearch, AiOutlineClose } from 'react-icons/ai'


function SearchBar({ placeholder, data }) {
  const [filteredData, setFilteredData] = useState([]);
  const [wordEntered, setWordEntered] = useState("");
// console.log(data)
  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const newFilter = data.filter((value) => {
      return value.title.toLowerCase().includes(searchWord.toLowerCase());
    });

    if (searchWord === "") {
      setFilteredData([]);
    } else {
      setFilteredData(newFilter);
    }
  };

  const clearInput = () => {
    setFilteredData([]);
    setWordEntered("");
  };

  return (
    <div className="p-1 bg-white rounded-md md:w-64  w-52">
      <div className="searchInputs w-full">
        <input
        className="w-full border-none"
          type="text"
          placeholder={placeholder || "Search..."}
          value={wordEntered}
          onChange={handleFilter}
        />
        <div className="">
          {filteredData.length === 0 ? (
            <AiOutlineSearch className="text-xl close" />
          ) : (
            <AiOutlineClose id="clearBtn" color="red" onClick={clearInput} />
          )}
        </div>
      </div>
      {filteredData.length !== 0 && (
        <div className="dataResult h-fit">
          {filteredData.slice(0, 15).map((value, key) => {
            return (
              <a className="" href={value.link} key={key} >
                <p className="w-fit">{value.title} </p>
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SearchBar;
